export class CountryCode {
  private static readonly _values: CountryCode[] = [];

  static readonly JP = new CountryCode('JP', '日本');
  static readonly US = new CountryCode('US', '米国');

  private constructor(readonly value: string, readonly ja: string) {
    CountryCode._values.push(this);
  }

  static values(): CountryCode[] {
    return CountryCode._values;
  }
}
